import { TreeEntry, TreeFile } from '../types';

const supportedRendererMapping = {
  md: 'markdown',
  markdown: 'markdown',
  mkd: 'markdown',
  mkdn: 'markdown',
  mdown: 'markdown',
  rst: 'rest',
  text: 'markdown',
  textile: 'textile',
};

type ParsedFilename = {
  basename: string;
  ext: string | null | undefined;
};

function parseFilename(filename: string): ParsedFilename {
  const parts = filename.toLowerCase().split('.');
  const basename = parts.length > 1 ? parts.slice(0, -1).join('.') : parts[0];
  const ext = parts.length > 1 ? parts[parts.length - 1] : null;
  return { basename, ext };
}

export function isReadme(filename: string): boolean {
  const { basename, ext } = parseFilename(filename);

  return (
    basename === 'readme' &&
    // @ts-ignore TODO: fix noImplicitAny error here
    (ext === null || (!!ext && !!supportedRendererMapping[ext]))
  );
}

export function getMarkupType(filename: string): string | null | undefined {
  const { basename, ext } = parseFilename(filename);

  if (!ext) {
    return basename === 'readme' ? 'markdown' : null;
  }

  // @ts-ignore TODO: fix noImplicitAny error here
  return supportedRendererMapping[ext];
}

export function getFirstReadme(
  entries: TreeEntry[]
): TreeFile | null | undefined {
  const readme = entries.find(
    entry => entry.type === 'file' && isReadme(entry.name)
  );
  return readme as TreeFile;
}
